module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container mt-5 mb-5"
  }, [(_vm.emailReminded === false) ? _c('div', {
    staticClass: "set-password__container mt-5 mb-5"
  }, [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v(_vm._s(_vm.$t('GENERATE_ACTIVATION_LINK')))]), _vm._v(" "), _c('p', {
    staticClass: "set-password__heading"
  }, [_vm._v(_vm._s(_vm.$t('INSERT_EMAIL_GIVEN_DURING_REGISTRATION')))]), _vm._v(" "), _c('form', {
    staticClass: "form--main mt-5 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    class: {
      control: true
    }
  }, [(_vm.errors.has('email')) ? _c('p', {
    staticClass: "validate-danger"
  }, [_c('img', {
    attrs: {
      "src": require("./../../../assets/images/icons/excl-red.svg")
    }
  }), _vm._v("\n                        " + _vm._s(_vm.$t('COMPLETE_FIELDS_CORRECTLY')) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: _vm.emailRegex
      }),
      expression: "{ required: true, regex: emailRegex }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "loginEmail",
    staticClass: "text-input -white-input-border",
    class: {
      validate: _vm.errors.any()
    },
    attrs: {
      "id": "loginEmail",
      "data-vv-validate-on": "none",
      "name": "email",
      "placeholder": _vm.$t('EMAIL_ADDRESS'),
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.remindPassword.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('SEND_WITHOUT_DOT')) + "\n            ")])])]) : _c('div', {
    staticClass: "text-xs-center mt-5 mb-5"
  }, [_c('p', {
    staticClass: "forgot-password-sent"
  }, [_c('img', {
    attrs: {
      "src": require("./../../../assets/images/icons/check-red.svg")
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('ACTIVATION_LINK_SENT_AGAIN')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToLogin.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('GO_BACK_TO_LOGIN_PAGE')) + "\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1134c770","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/activate-account/send-activation-link-again.vue
// module id = 1164
// module chunks = 0